import styled from 'styled-components';

export const LinkButton = styled.button`
  outline: 0;
  border: 0;
  background: 0;
  color: ${({ theme }) => theme.colors.primary.cyan};
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.midBlue};
    text-decoration: underline;
  }
`;
